import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from "@material-ui/core";

import { apollo_useStyles } from "../../../atom/Apollo_styles";

type ActiveDialogProps = {
  open: boolean,
  type: "audience" | "setpoint",
  name: string,
  handleSave: any,
  handleClose: any,
}

const ActiveDialog = (props: ActiveDialogProps) => {

  const classes = apollo_useStyles();

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
      >
        <DialogTitle>
          <Typography variant="subtitle1">
            {props.type === "audience" ? "オーディエンス" : "測定ポイント"}停止
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1">
              {props.name} を停止しますか？
            </Typography>
            <Typography variant="body1">
              {props.type === "audience"
                ? "※停止後はサイト来訪ログなどの蓄積停止となりますのでご注意ください"
                : "※停止後は効果測定対象外となりますのでご注意ください"
              }
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            className={classes.button}
            onClick={async() => {
              props.handleClose();
              await props.handleSave();
            }}
            variant="contained"
          >
            更新
          </Button>
          <Button
            color="primary"
            className={classes.button}
            onClick={props.handleClose}
            variant="contained"
          >
            戻る
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
export default ActiveDialog;
